import React from 'react';

export function WriteIcon(props: JSX.IntrinsicElements['svg']) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.108 1.883a1.98 1.98 0 00-1.376.552L13.578 14.196l-.458 3.107 3.21-.444L28.484 5.098c.365-.354.57-.833.57-1.332 0-.5-.205-.978-.57-1.331a1.98 1.98 0 00-1.376-.552zm-2.752-.78A3.959 3.959 0 0127.108 0c1.032 0 2.022.397 2.752 1.103A3.705 3.705 0 0131 3.766c0 .999-.41 1.957-1.14 2.663L17.476 18.412a.986.986 0 01-.55.267l-4.815.666a.993.993 0 01-.826-.266.923.923 0 01-.275-.799l.687-4.66a.93.93 0 01.276-.534L24.355 1.103z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.885 7.668c-.255 0-.5.098-.68.272a.916.916 0 00-.282.658v18.61c0 .247.101.484.282.658.18.175.425.273.68.273h19.23c.255 0 .5-.098.68-.273a.916.916 0 00.282-.658v-9.305c0-.514.43-.93.961-.93.532 0 .962.416.962.93v9.305c0 .74-.304 1.45-.845 1.974a2.934 2.934 0 01-2.04.818H2.885a2.934 2.934 0 01-2.04-.818A2.747 2.747 0 010 27.208V8.598c0-.74.304-1.45.845-1.974a2.934 2.934 0 012.04-.818H12.5c.531 0 .961.417.961.931s-.43.93-.961.93H2.885z"
                fill="currentColor"
            />
        </svg>
    );
}
